var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChains(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99982 5.1665C2.05115 5.1665 0.492777 6.83866 0.68211 8.82666C0.847443 10.56 2.40171 11.8332 4.14305 11.8332H5.99982C6.36782 11.8332 6.66648 11.5345 6.66648 11.1665C6.66648 10.7985 6.36782 10.4998 5.99982 10.4998H4.1131C3.03043 10.4998 2.05972 9.68861 2.00372 8.60661C1.94306 7.45327 2.85982 6.49984 3.99982 6.49984H5.99982C6.36782 6.49984 6.66648 6.20117 6.66648 5.83317C6.66648 5.46517 6.36782 5.1665 5.99982 5.1665H3.99982ZM9.99982 5.1665C9.63182 5.1665 9.33315 5.46517 9.33315 5.83317C9.33315 6.20117 9.63182 6.49984 9.99982 6.49984H11.8865C12.9692 6.49984 13.9399 7.31107 13.9959 8.39307C14.0566 9.5464 13.1398 10.4998 11.9998 10.4998H9.99982C9.63182 10.4998 9.33315 10.7985 9.33315 11.1665C9.33315 11.5345 9.63182 11.8332 9.99982 11.8332H11.9998C13.9485 11.8332 15.5069 10.161 15.3175 8.17301C15.1522 6.43968 13.5979 5.1665 11.8566 5.1665H9.99982ZM5.33315 7.83317C4.96515 7.83317 4.66648 8.13184 4.66648 8.49984C4.66648 8.86784 4.96515 9.1665 5.33315 9.1665H10.6665C11.0345 9.1665 11.3332 8.86784 11.3332 8.49984C11.3332 8.13184 11.0345 7.83317 10.6665 7.83317H5.33315Z",
    fill: "#03F5AE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChains);
export default __webpack_public_path__ + "static/media/chains.aaef292c75fbfd0ee388c822123ed83f.svg";
export { ForwardRef as ReactComponent };